<template>
    <div
        id="deposit-list-modal"
        class="uk-modal"
        :container="container"
    >
        <div class="uk-modal-dialog uk-modal-body">
            <h2 class="uk-modal-title">
                Generate Deposit List
            </h2>
            <p>
                Please confirm you have selected the correct transactions before generating the deposit list PDF.
            </p>
            <table class="uk-table uk-table-divider uk-table-justify">
                <tr
                    v-for="deposit in selectedDeposits"
                    :key="deposit.id"
                >
                    <td colspan="7">
                        {{ getCustomerFullname(deposit) }} ({{ deposit.paymentMethod }})
                    </td>
                    <td
                        colspan="5"
                        :style="{textAlign: 'right'}"
                    >
                        ${{ formatPrice(deposit.amount) }}
                    </td>
                </tr>
                <tr>
                    <td colspan="7">
                        <strong>Total: </strong>
                    </td>
                    <td
                        colspan="5"
                        :style="{textAlign: 'right'}"
                    >
                        ${{ total }}
                    </td>
                </tr>
            </table>

            <div class="uk-text-right">
                <button
                    class="uk-button uk-button-default uk-modal-close"
                    type="button"
                >
                    Cancel
                </button>
                <button
                    class="uk-button uk-button-primary uk-margin-left"
                    type="button"
                    @click="getDepositSlip()"
                >
                    OK
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatPrice, log } from "@strangeanimals/common-vue-components/src/helpers/helpers";

export default {
    name: "DepositListModal",
    props: {
        container: {
            type: [String, Boolean],
            default: false
        },
    },
    computed: {
        ...mapGetters({
            payments: 'payments',
            depositList: 'depositList'
        }),
        selectedDeposits() {
            let payments = this.payments.filter(payment => this.depositList.includes(payment.id));
            return payments;
        },
        total() {
            let total = 0
            for (let i = 0; i < this.selectedDeposits.length; i++) {
                total += Number(this.selectedDeposits[i]['amount'])
            }
            return formatPrice(total.toFixed(2))
        },
    },
    methods: {
        formatPrice(amount) {
            return formatPrice(amount);
        },
        getDepositSlip() {
            this.$emit('getDepositSlip')
        },
        getCustomerFullname(deposit) {
            try {
                return deposit.paidBy.fullName;
            }
            catch(err) {
                log('Customer full name is not set for job id: ' + deposit.jobNumber + '.');
                return "";
            }
        }
    }

}
</script>
